/* eslint-disable react/destructuring-assignment */
// Material UI imports
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import { injectIntl } from 'react-intl';

import UserContainer from './components/UserContainer';

// Dashboard container import
import DashboardContainer from '../DashboardContainer';

const User = props => {
  const { windowSize, intl, history } = props;

  const fullPanel = [
    {
      id: 'User',
      component: <UserContainer intl={intl} windowSize={windowSize} />,
    },
  ];

  return (
    <Grid item xs={12}>
      <DashboardContainer
        history={history}
        standalone
        displayWarning={false}
        fullPanel={fullPanel}
        panelStyle="fullPanel"
        backgroundColor="#F5F5F5"
        {...props}
        windowSize={windowSize}
      />
    </Grid>
  );
};

User.propTypes = {
  history: PropTypes.object.isRequired,
  windowSize: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(User);
